import React from "react";
import "../internalTools.css";

const InternalToolsHome = ({ tools = [] }) => (
    <main className="app-shell">
        <div className="internal-tools-shell">
            <header className="internal-tools-header">
                <div className="internal-tools-header__copy">
                    <p className="internal-tools-header__eyebrow">Hosted calculator library</p>
                    <h1>Financial Edge Calculators</h1>
                    <p>
                        Pick the calculator by the job you are trying to do, open it, and work
                        straight through the scenario. Each tool is laid out to read top to bottom,
                        with the result kept obvious and the next step easy to find.
                    </p>
                </div>
                <div className="internal-tools-header__aside">
                    <div className="internal-tools-header__aside-card">
                        <p className="internal-tools-header__aside-label">Hosted together</p>
                        <p className="internal-tools-header__aside-value">{tools.length}</p>
                        <p className="internal-tools-header__aside-copy">
                            Standalone calculators ready for direct use.
                        </p>
                    </div>
                </div>
            </header>

            <div className="internal-tool-launch-grid">
                {tools.map((tool) => (
                    <section key={tool.key} className="internal-tool-launch-card">
                        <div className="internal-tool-card__header internal-tool-card__header--compact">
                            <div>
                                <p className="internal-tool-card__eyebrow">{tool.eyebrow}</p>
                                <h2>{tool.title}</h2>
                                <p>{tool.summary}</p>
                            </div>
                        </div>
                        {tool.bestFor ? (
                            <div className="internal-tool-launch-card__focus">
                                <span className="internal-tool-launch-card__focus-label">Best for</span>
                                <span className="internal-tool-launch-card__focus-copy">{tool.bestFor}</span>
                            </div>
                        ) : null}
                        {tool.highlights?.length ? (
                            <div className="internal-tool-launch-card__highlights">
                                {tool.highlights.map((highlight) => (
                                    <span key={highlight} className="internal-tool-launch-card__pill">
                                        {highlight}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                        <div className="internal-tool-launch-card__footer">
                            <span className="internal-tool-launch-card__meta">
                                Opens in its own route
                            </span>
                            <a
                                className="internal-tool-launch-card__link"
                                href={tool.routePath || `/?tool=${tool.key}`}
                            >
                                Open tool
                            </a>
                        </div>
                    </section>
                ))}
            </div>
        </div>
    </main>
);

export default InternalToolsHome;
